import React, { useState, useEffect } from 'react';
import { Table, Input, Typography, Spin, Tag, Button, Card } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useAppContext } from '@/components/AppContext';
import { A4B_APPS } from '@/utils/constants';

const { Title, Text } = Typography;

const Container = styled(Card)`
  display: flex;
  flex-direction: column;

  .ant-card-body {
    flex-grow: 1;
  }
`;
const { Search } = Input;

interface StoreData {
    key: number;
    id: string;
    store_name: string;
    total_items: number;
    total_orders: number;
    status: string;
}

const StoreListSankalp = () => {
    const [state, setState] = useState({
        data: [] as StoreData[],
        loading: false,
        hasMore: true,
        page: 1,
        isSearching: false,
        limit: 10,
        offset: 0
    });
    const { networkInstance, app, languageState } = useAppContext();

    const monetisationPujaApi = app === A4B_APPS.SRIMANDIR
        ? networkInstance.clientWithHeaders.monetisationPujaApi
        : networkInstance.clientWithHeaders.monetisationAstroPujaApi;

    const fetchStores = async (offset = 0, search = '') => {
        try {
            const response = await monetisationPujaApi?.sankalpSheetApi?.getStoreListPageSankalp({
                store_id: search,
                limit: state.limit,
                offset: offset
            });

            return {
                data: response?.data?.data?.stores || [],
                is_last_page: !response?.data?.data?.stores || response?.data?.data?.stores.length < state.limit
            };
        } catch (error) {
            console.error('Error fetching stores:', error);
            return { data: [], is_last_page: true };
        }
    };

    const loadData = async (offset = 0, search = '', append = false) => {
        if (state.loading) return;
        setState(prev => ({ ...prev, loading: true }));

        const result = await fetchStores(offset, search);

        setState(prev => ({
            ...prev,
            data: append ? [...prev.data, ...result.data] : result.data,
            hasMore: !result.is_last_page,
            offset: search ? prev.offset : offset + result.data.length,
            loading: false,
            isSearching: !!search.trim()
        }));
    };

    useEffect(() => {
        loadData(0);
    }, []);

    const columns: any = [
        {
            title: 'S.No.',
            dataIndex: 'key',
            width: 80,
            align: 'center',
            render: (_: any, record: StoreData, index: number) => index + 1
        },
        {
            title: 'Store Id',
            dataIndex: 'id',
            width: 300,
            render: (text: string) => {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('store_id', text);
                return <a href={currentUrl.toString()}>{text}</a>;
            }
        },
        { title: 'Store Name', dataIndex: 'store_name', width: 300 },
        { title: 'Items', dataIndex: 'total_items', width: 150, align: 'center' },
        { title: 'Bookings', dataIndex: 'total_orders', width: 180, align: 'center' }
    ];

    return (
        <div style={{ padding: '40px' }}>
            <Container style={{ width: '100%' }}>
                <Title level={3} style={{ marginBottom: 24 }}>Manage Sankalp Sheet</Title>

                <Search
                    placeholder="Store ID"
                    allowClear
                    size="large"
                    onSearch={(v) => loadData(0, v)}
                    onChange={(e) => !e.target.value && loadData(0, '')}
                    style={{ width: "16%", marginBottom: 20 }}
                />

                <Table
                    columns={columns}
                    dataSource={state.data}
                    loading={state.loading}
                    pagination={false}
                    rowKey="id"
                />

                {state.hasMore && !state.isSearching && (
                    <div style={{ textAlign: 'center', marginTop: 16 }}>
                        <Button
                            onClick={() => loadData(state.offset, '', true)}
                            loading={state.loading}
                            type="primary"
                        >
                            Load More
                        </Button>
                    </div>
                )}
            </Container>
        </div>
    );
};

export default StoreListSankalp;